import { render, staticRenderFns } from "./fix_orderDetail.vue?vue&type=template&id=287cbbad&scoped=true"
import script from "./fix_orderDetail.vue?vue&type=script&lang=js"
export * from "./fix_orderDetail.vue?vue&type=script&lang=js"
import style0 from "./fix_orderDetail.vue?vue&type=style&index=0&id=287cbbad&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287cbbad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('287cbbad')) {
      api.createRecord('287cbbad', component.options)
    } else {
      api.reload('287cbbad', component.options)
    }
    module.hot.accept("./fix_orderDetail.vue?vue&type=template&id=287cbbad&scoped=true", function () {
      api.rerender('287cbbad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderBox/fix_orderDetail/fix_orderDetail.vue"
export default component.exports